import { get } from "svelte/store";
import { project } from "$lib/services/store";

/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
  // TODO: this works, but project is not defined on client-side and causes error. Hence I have added the fallback of the 'redirectUrl' to avoid getting the error.
  const redirectUrl = get(project) ?? { "settings": { "redirectUrl": "go"} }

  return param === redirectUrl.settings.redirectUrl
}